<script setup lang="ts">
import type { PersistentStudioWorkspace } from '@/features/ai-visualization/studio/persistent-studio.ts';
import Toast from 'primevue/toast';
import { computed, defineAsyncComponent, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
// import { onBeforeUnmount, onMounted, watch } from 'vue';
// import { useRouter } from 'vue-router';
import { Toaster } from '@/components/ui/toast';
import { shouldRenderStudioWorkspace, studioIdentity } from '@/features/ai-visualization/studio/persistent-studio.ts';
// import { browseApi } from './api/track/trackApi';
//
// const router = useRouter();
//
// async function enterPage() {
//   try {
//     await browseApi('ENTER', window.location.href);
//     console.log('Entered');
//   }
//   catch (error) {
//     console.error('Error tracking page enter:', error);
//   }
// }
//
// async function leavePage() {
//   try {
//     await browseApi('LEAVE', window.location.href);
//     console.log('Leave');
//   }
//   catch (error) {
//     console.error('Error tracking page leave:', error);
//   }
// }
//
// onMounted(async () => {
//   await enterPage();
// });
//
// onBeforeUnmount(async () => {
//   await leavePage();
// });
//
// watch(
//   () => router.currentRoute.value,
//   async (to, from) => {
//     if (from) {
//       await leavePage(); // 离开之前的页面
//     }
//     if (to) {
//       await enterPage(); // 进入新的页面
//     }
//   },
// );
const route = useRoute();
const StudioWorkspace = defineAsyncComponent(() => import('@/features/ai-visualization/v2/studio/VisualizationStudioPage.vue'));
const currentStudio = computed(() => studioIdentity(route));
const studioRouteActive = computed(() => currentStudio.value !== null);
const studioWorkspaces = ref<PersistentStudioWorkspace[]>([]);

function ensureStudioWorkspace(identity: PersistentStudioWorkspace): void {
  if (!studioWorkspaces.value.some(workspace => workspace.key === identity.key))
    studioWorkspaces.value = [...studioWorkspaces.value, identity];
}

watch(currentStudio, (identity) => {
  if (identity)
    ensureStudioWorkspace(identity);
}, { immediate: true });

function updateStudioTaskLiveness(key: string, active: boolean): void {
  studioWorkspaces.value = studioWorkspaces.value.flatMap((workspace) => {
    if (workspace.key !== key)
      return [workspace];
    const updated = { ...workspace, taskActive: active };
    return !active && currentStudio.value?.key !== key ? [] : [updated];
  });
}

const renderedStudioWorkspaces = computed(() => studioWorkspaces.value.filter(workspace =>
  shouldRenderStudioWorkspace(workspace, currentStudio.value?.key),
));
</script>

<template>
  <div class="h-full w-full">
    <router-view v-slot="{ Component }">
      <Transition name="page" mode="out-in">
        <component :is="Component" v-if="!studioRouteActive" />
      </Transition>
    </router-view>
    <div
      v-for="workspace in renderedStudioWorkspaces"
      :key="workspace.key"
      class="persistent-studio-host"
      :class="{ 'is-background-execution': workspace.key !== currentStudio?.key }"
      :aria-hidden="workspace.key !== currentStudio?.key"
      :inert="workspace.key !== currentStudio?.key"
    >
      <StudioWorkspace
        :project-id="workspace.projectId"
        @task-liveness="updateStudioTaskLiveness(workspace.key, $event)"
      />
    </div>
    <Toast />
    <Toaster />
  </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity var(--motion-duration-base) var(--motion-ease-standard),
    transform var(--motion-duration-base) var(--motion-ease-standard);
}

.page-enter-from {
  opacity: 0;
  transform: translateY(8px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

@media (prefers-reduced-motion: reduce) {
  .page-enter-active,
  .page-leave-active {
    transition: opacity 0.01ms linear;
    transform: none;
  }
}

.persistent-studio-host {
  width: 100%;
  height: 100%;
}

.persistent-studio-host.is-background-execution {
  position: fixed;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
</style>
